module.exports = __webpack_public_path__ + "img/more-horizontal.f0e83cb8.svg";